module.exports = __webpack_public_path__ + "static/media/learning1.758659f6.png";